import React, { useEffect, useState } from 'react';
const PURCHASE_LINK = 'https://f13dpf-q0.myshopify.com/cart/47511845830810:1?channel=buy_button';
const entries = [{
  name: 'Valentina R.',
  location: 'Córdoba'
}, {
  name: 'Mariana T.',
  location: 'Mendoza'
}, {
  name: 'Andrea L.',
  location: 'Tucumán'
}, {
  name: 'Camila P.',
  location: 'Buenos Aires'
}, {
  name: 'Sofía M.',
  location: 'Tierra del Fuego'
}, {
  name: 'Luciana B.',
  location: 'Rosario'
}, {
  name: 'Florencia G.',
  location: 'La Plata'
}, {
  name: 'Natalia V.',
  location: 'Salta'
}, {
  name: 'Romina C.',
  location: 'Mar del Plata'
}, {
  name: 'Daniela M.',
  location: 'Neuquén'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const [animClass, setAnimClass] = useState('popup-enter');
  useEffect(() => {
    // Show for 4s, hide for 2s, then show next
    const cycle = () => {
      // Start exit
      setAnimClass('popup-exit');
      setTimeout(() => {
        setVisible(false);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % entries.length);
          setVisible(true);
          setAnimClass('popup-enter');
        }, 200);
      }, 400);
    };
    const timer = setInterval(cycle, 5000);
    return () => clearInterval(timer);
  }, []);
  if (!visible) return null;
  const entry = entries[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs ${animClass}`} style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-5">
      <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block" data-id="element-6">
        <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-3 flex items-start gap-3 cursor-pointer hover:shadow-3xl transition-shadow" data-id="element-7">
          <div className="text-2xl flex-shrink-0" data-id="element-8">🛍️</div>
          <div className="flex-1 min-w-0" data-id="element-9">
            <div className="flex items-center gap-1 mb-0.5" data-id="element-10">
              <span className="text-green-600 text-xs font-bold" data-id="element-11">
                ✅ Compra verificada
              </span>
            </div>
            <p className="text-gray-800 text-xs font-semibold leading-tight" data-id="element-12">
              <span className="text-gray-900 font-bold" data-id="element-13">{entry.name}</span> de{' '}
              {entry.location}, Argentina
            </p>
            <p className="text-gray-600 text-xs leading-tight mt-0.5" data-id="element-14">
              acaba de comprar el{' '}
              <span className="font-bold text-gray-800" data-id="element-15">
                MEGA PACK FÓRMULA UGC
              </span>{' '}
              ✅
            </p>
            <p className="text-gray-400 text-xs mt-1" data-id="element-16">Hace unos minutos</p>
          </div>
        </div>
      </a>
    </div>;
}